import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ profile }) => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">{profile?.nameWithCredentials || profile?.name}</h3>
            <p className="text-slate-300 text-sm leading-relaxed mb-4">
              {profile?.title}
            </p>
            <div className="flex items-center space-x-2 text-slate-300 text-sm">
              <MapPin className="w-4 h-4" />
              <span>{profile?.location}</span>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: 'About', id: 'about' },
                { label: 'Clinical Expertise', id: 'expertise' },
                { label: 'Achievements', id: 'achievements' },
                { label: 'Hospital Affiliation', id: 'hospital' },
                { label: 'Conditions Treated', id: 'conditions' },
                { label: 'Clinical Insights', id: 'clinical-insights' },
                { label: 'Education Videos', id: 'education-videos' },
                { label: 'Contact', id: 'contact' }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-slate-300 hover:text-teal-400 transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${profile?.contact?.email}`}
                  className="flex items-center space-x-3 text-slate-300 hover:text-teal-400 transition-colors text-sm group"
                >
                  <div className="p-2 bg-slate-800 rounded-lg group-hover:bg-teal-600 transition-colors">
                    <Mail className="w-4 h-4" />
                  </div>
                  <span className="break-all">{profile?.contact?.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${profile?.contact?.phone}`}
                  className="flex items-center space-x-3 text-slate-300 hover:text-teal-400 transition-colors text-sm group"
                >
                  <div className="p-2 bg-slate-800 rounded-lg group-hover:bg-teal-600 transition-colors">
                    <Phone className="w-4 h-4" />
                  </div>
                  <span>{profile?.contact?.phone}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-slate-400 text-sm text-center sm:text-left">
              © {currentYear} Dr. {profile?.name?.split(' ').slice(-2).join(' ')}. All rights reserved.
            </p>
            <p className="text-slate-400 text-sm text-center sm:text-right">
              Professional medical profile for informational purposes only.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;